export default __webpack_public_path__ + "static/media/placeholder_private03-jp-mobile.1c537c08.png";